export const isValue = (value: string | number): boolean => !!value;

type StringOrNumber = string | number;

export const allNotEmpty = (list: StringOrNumber[]) => list.every((x) => isValue(x));
